import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { AssetIcon, type AssetIconProps } from './AssetIcon';
import { SparkleIcon } from './SparkleIcon';

export type ApprovalAiIconProps = Omit<AssetIconProps, 'src' | 'alt'>;

/** AI sparkle on review-and-confirm rows — AG purple sparkle, HID light-blue confirm asset. */
export function ApprovalAiIcon({ size = 18, className, ...props }: ApprovalAiIconProps) {
  const brandConfig = getBrandConfig();

  if (APP_BRAND === 'hid' && brandConfig.hidAiConfirmIcon) {
    const scale = size / 18;
    return (
      <AssetIcon
        src={brandConfig.hidAiConfirmIcon}
        width={Math.round(18 * scale)}
        height={Math.round(17 * scale)}
        className={className}
        alt=""
        aria-hidden
        {...props}
      />
    );
  }

  return <SparkleIcon className={className} size={size} {...props} />;
}
